module.exports = __webpack_public_path__ + "static/media/weekend_papers_footy2024.17710b79.webp";